import * as React from "react";

function SvgBBiconsUlozit(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path
        d="M47.26 29.63a17.63 17.63 0 00-17.63 17.63v105.48a17.62 17.62 0 0017.63 17.63h105.48a17.63 17.63 0 0017.63-17.63V64.8L135 29.63h-10.29v35.56a7.06 7.06 0 01-7 7.06H63.07a7.06 7.06 0 01-7-7.06V29.63zm56.28 5.88a3.36 3.36 0 00-3.54 3.17v22.55a3.36 3.36 0 003.53 3.15h10.13a3.36 3.36 0 003.53-3.15V38.68a3.36 3.36 0 00-3.53-3.17zm-48 61.55h88.75a10.27 10.27 0 0110.35 10.18v42.4a10.25 10.25 0 01-10.35 10.16H55.51a10.25 10.25 0 01-10.35-10.16v-42.4a10.27 10.27 0 0110.35-10.18z"
        data-name="Obecn\xE9 ikony"
      />
    </svg>
  );
}

export default SvgBBiconsUlozit;

